import React, { useEffect, useRef, useState } from 'react'
import '../../global'
import Spinner from '../../components/LoadingSpinner'

import { Platform, Image } from 'react-native'

import { StripeLoader } from '../../components/Stripe/StripeLoader'

import { Helmet } from 'react-helmet'

import { useAppDispatch, useAppSelector } from '../../state/hooks'

import { useRetrieveDataContext } from '../../context/RetrieveDataContext'

export default function RetrieveData({ children }) {
	const dispatch = useAppDispatch()
	const { spinner, loading, appleAppId } = useRetrieveDataContext()
	const { loadedData, allDataLoaded, stripePublishableKey } = useAppSelector(state => state.data)

	const _ = require('lodash')

	const [stripePublishableKeyLocalState, setStripePublishableKey] = useState('')

	const ref = useRef(null)
	global.payRef = ref

	return (
		<>
			{Platform.OS === 'web' && appleAppId && (
				<Helmet>
					<meta name="apple-itunes-app" content={`app-id=${appleAppId}`} />
				</Helmet>
			)}
			<Spinner
				visible={global.kiosk ? !allDataLoaded : spinner && loading}
				overlayColor="rgba(255, 255, 255, 1)"
				headerHeight={0}
				footerHeight={0}
				color="black"
				customIndicator={
					<Image
						style={{ width: 100, height: 100, alignSelf: 'center', marginTop: -20 }}
						source={require('../../assets/images/loadImg.gif')}
					/>
				}
			/>
			{!spinner && !loading && (
				<StripeLoader
					stripePublishableKey={
						stripePublishableKey === '' ? stripePublishableKeyLocalState : stripePublishableKey
					}
				>
					{children}
				</StripeLoader>
			)}
		</>
	)
}
